import BiodiversityMetricBase from './BiodiversityMetricsBase.js'
import type { SinkConfig, SinkId, SourceId } from '../../../../Flux/Slice/Visualization/VisualizationSliceTypes.js'

export function BiodiversityRichnessSink({ sourceId, sinkId, config }: { sourceId: SourceId; sinkId: SinkId; config: SinkConfig }) {
  return (
    <BiodiversityMetricBase
      sourceId={sourceId}
      sinkId={sinkId}
      config={{ ...config, params: { ...config.params, metric: 'speciesRichness' } }}
    />
  )
}

export function BiodiversityShannonSink({ sourceId, sinkId, config }: { sourceId: SourceId; sinkId: SinkId; config: SinkConfig }) {
  return (
    <BiodiversityMetricBase sourceId={sourceId} sinkId={sinkId} config={{ ...config, params: { ...config.params, metric: 'shannon' } }} />
  )
}

export function BiodiversityGiniSimpsonSink({ sourceId, sinkId, config }: { sourceId: SourceId; sinkId: SinkId; config: SinkConfig }) {
  return (
    <BiodiversityMetricBase
      sourceId={sourceId}
      sinkId={sinkId}
      config={{ ...config, params: { ...config.params, metric: 'giniSimpson' } }}
    />
  )
}

export function BiodiversityAbsoluteEffectiveSink({
  sourceId,
  sinkId,
  config
}: {
  sourceId: SourceId
  sinkId: SinkId
  config: SinkConfig
}) {
  return (
    <BiodiversityMetricBase
      sourceId={sourceId}
      sinkId={sinkId}
      config={{ ...config, params: { ...config.params, metric: 'absoluteEffective' } }}
    />
  )
}
